import { Injectable } from '@angular/core';
import { Chart, ChartOptions } from 'chart.js';
@Injectable({
  providedIn: 'root'
})
export class ChartService {
  createHorizontalBarChart(
    ctx: CanvasRenderingContext2D,
    labels: string[],
    type:string,
    data: number[],
    chartOptions: ChartOptions
  ): Chart {
    return new Chart(ctx, {
      type: type,
      data: {
        labels: labels,
        datasets: [
          {
            label: chartOptions.datasetLabel || '',
            data: data,
            backgroundColor: chartOptions.backgroundColor || 'rgba(241, 0, 150, 1)',
            borderColor: chartOptions.borderColor || 'rgba(241, 0, 150, 1)',
            borderWidth: chartOptions.borderWidth || 1,
          },
        ],
      },
      options: {
        scales: {
          x: {
            beginAtZero: chartOptions.xBeginAtZero || true,
            max: chartOptions.xMax || Math.max(...data) + 10,
          },
          y: {
            ticks: {
              autoSkip: chartOptions.yAutoSkip || false,
            },
          },
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, chartData) {
              return chartOptions.tooltipLabel
                ? chartOptions.tooltipLabel + ': ' + tooltipItem.xLabel
                : tooltipItem.xLabel;
            },
          },
        },
        legend: {
          display: chartOptions.displayLegend || false,
        },
      },
    });
  }
}
